import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Text from '../../../shared/Text';
import { useBroadcastContext } from '../contexts/BroadcastContext.jsx';
import { Header, TopHeader } from '../shared/Styles';

import { ContactSummary } from './Audience/ContactSummary.jsx';
import { SegmentTargeting } from './Audience/SegmentTargeting.jsx';

import { PAID } from '../utils/constants';

export const Audience = () => {
  const { t } = useTranslation('broadcasts');
  const {
    setValues,
    setFieldValue,
    errors,
    userCount,
    emailCount,
    smsCount,
    values,
    tier,
  } = useBroadcastContext();

  const [sms, setSms] = useState(
    values.broadcastType === 'sms' || values.broadcastType === 'both',
  );
  const [email, setEmail] = useState(
    values.broadcastType === 'email' || values.broadcastType === 'both',
  );
  const isSmsEnabled = sms && smsCount > 0;

  useEffect(() => {
    if (values.broadcastType === 'both') {
      setSms(true);
      setEmail(true);
    } else if (values.broadcastType === 'sms') {
      setSms(true);
      setEmail(false);
    } else if (values.broadcastType === 'email') {
      setSms(false);
      setEmail(true);
    }
  }, [values.broadcastType]);

  useEffect(() => {
    if (isSmsEnabled && email) {
      setFieldValue('broadcastType', 'both');
    } else if (isSmsEnabled) {
      setValues({ ...values, broadcastType: 'sms', campaignUuid: null });
    } else if (email) {
      setFieldValue('broadcastType', 'email');
    } else {
      setFieldValue('broadcastType', null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sms, smsCount, email, setFieldValue, setValues]);

  return (
    <>
      <TopHeader>
        <Text variant="h5">{t('audience.audience')}</Text>
      </TopHeader>
      {tier === PAID && <SegmentTargeting />}
      <ContactSummary
        userCount={userCount}
        emailCount={emailCount}
        smsCount={smsCount}
      />
      <Header>
        <Text variant="h5">{t('audience.chooseBroadcast')}</Text>
      </Header>
      <BroadcastSelection>
        <BroadcastType checked={isSmsEnabled}>
          <input
            type="checkbox"
            checked={isSmsEnabled}
            disabled={smsCount === 0}
            onChange={e => setSms(e.target.checked)}
          />
          <Text variant="subtitle2" ml="8px">
            {t('audience.sms')}
          </Text>
        </BroadcastType>
        <BroadcastType checked={email}>
          <input
            type="checkbox"
            checked={email}
            onChange={e => setEmail(e.target.checked)}
          />
          <Text variant="subtitle2" ml="8px">
            {t('audience.email')}
          </Text>
        </BroadcastType>
      </BroadcastSelection>
      <BroadcastTypeError error={errors.broadcastType} />
    </>
  );
};

const BroadcastTypeError = ({ error }) => {
  if (!error) return null;
  return (
    <ErrorContainer>
      <Text color="red">
        <ErrorIcon />
        {error}
      </Text>
    </ErrorContainer>
  );
};

const ErrorIcon = styled.i.attrs({
  className: 'fa-regular fa-circle-info',
})`
  margin-right: 5px;
`;

const BroadcastSelection = styled.div`
  padding: 20px;
`;
const BroadcastType = styled.label`
  background: ${props => (props.checked ? '#CCE5FF' : '#fff')};
  border: 1px solid ${props => (props.checked ? '#007EFF' : '#DBDDE0')};
  border-radius: 12px;
  padding: 16px;
`;

const Container = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

const ErrorContainer = styled(Container)`
  padding: 0px 20px 25px 20px;
`;
